import { TimeInput } from './TimeInput';
import { HourState } from '../_types';
import { useInputs } from '../useInputs';

export const HourInput = () => {
  const { state, setState, isView } = useInputs<HourState>();
  return (
    <TimeInput
      time={state.startAtMinute}
      onTimeChange={(newTime) =>
        setState((state) => ({ ...state, startAtMinute: newTime }))
      }
      label="Start at minute:"
      sx={{
        overflow: 'visible',
        '& .MuiFormLabel-root': { overflow: 'visible' },
      }}
      InputProps={{ readOnly: isView }}
      mode="mm"
    />
  );
};
